// extracted by mini-css-extract-plugin
module.exports = {"VerifyEmail":"VerifyEmail_VerifyEmail__AnajQ","Link":"VerifyEmail_Link__1g_Yf"};